import { Address } from "src/types/listing";
import { useFetchCreditsBalance } from "../../hooks/useFetchCreditsBalance";
import { SearchResultsCard, ErrorResults, NoMatchingResults } from "./SharedComponents";
import { MatchingResults } from "./MatchingResults";


export interface AddressSearchResultsProps {
  searchName: string;
  onSearchNameChange: (searchName: string) => void;
  onSaveSearchClick: (payload: { searchName: string }) => void;
  searchQueryAddress: string;
  searchResultAddress: Address;
  creditCost?: number;
  isSaving?: boolean;
  isFetching?: boolean;
  isError?: boolean;
  error?: Error | null;
  onClearSearchClick: () => void;
}

export const AddressSearchResults = ({
  searchName,
  onSearchNameChange,
  onSaveSearchClick,
  onClearSearchClick,
  searchQueryAddress,
  searchResultAddress,
  creditCost = 0,
  isSaving = false,
  isFetching = false,
  isError = false,
  error = null,
}: AddressSearchResultsProps) => {
  const { data: creditsData } = useFetchCreditsBalance();
  const availableCredits = creditsData?.balance;
  const formattedCredits = creditsData?.formattedBalance;

  const hasMatchingResults = (
    <MatchingResults
      title={
        <>
          <div className="text-base font-medium text-gray-500">
            {creditCost === 1 ? "1 Property found" : `${creditCost} Properties found`}
          </div>
          {searchQueryAddress}
        </>
      }
      creditCost={creditCost}
      availableCredits={availableCredits ?? null}
      formattedCredits={formattedCredits}
      isFetching={isFetching}
      searchName={searchName}
      onSearchNameChange={onSearchNameChange}
      onSaveSearchClick={() => onSaveSearchClick({ searchName })}
      onClearSearchClick={onClearSearchClick}
      isSaving={isSaving}
      autoFocusAndSelect={true}
      autoFocusTrigger={searchResultAddress}
    />
  );

  // Show skeleton when fetching and no properties yet
  if (isFetching && !searchResultAddress) {
    return <SearchResultsCard showSkeleton={true} />;
  }

  return (
    <SearchResultsCard>
      {isError ? (
        <ErrorResults error={error} isFetching={isFetching} onClearSearchClick={onClearSearchClick} />
      ) : !searchResultAddress ? (
        <NoMatchingResults
          title="No Information Found"
          message="No information found for the address you selected."
          isFetching={isFetching}
          onClearSearchClick={onClearSearchClick}
        />
      ) : (
        hasMatchingResults
      )}
    </SearchResultsCard>
  );
};
